const state = {
  isLoading: false,
  data: [],
  brandCategories: {
    tree: [],
  },
};

export default state;
